import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Login.css'; // Login ile aynı CSS kullanıyoruz

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // TODO: Backend'de şifre sıfırlama endpoint'i eklendiğinde burası güncellenecek
      // await authAPI.forgotPassword(email);

      // Şimdilik simülasyon
      await new Promise(resolve => setTimeout(resolve, 2000));

      setSuccess(true);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-split-container">
      {/* Sol Taraf - Görsel Alan */}
      <div className="login-visual-side">
        <div className="visual-overlay"></div>
        <div className="visual-content">
          <div className="visual-logo">
            <i className="bi bi-bank2"></i>
          </div>
          <h1 className="visual-title">Karadaş Hukuk Bürosu</h1>
          <p className="visual-subtitle">Şifre Kurtarma Merkezi</p>
          <div className="visual-features">
            <div className="feature-item">
              <i className="bi bi-envelope-check"></i>
              <span>E-posta Doğrulama</span>
            </div>
            <div className="feature-item">
              <i className="bi bi-key"></i>
              <span>Güvenli Sıfırlama</span>
            </div>
            <div className="feature-item">
              <i className="bi bi-clock-history"></i>
              <span>Hızlı İşlem</span>
            </div>
          </div>
        </div>
      </div>

      {/* Sağ Taraf - Form Alanı */}
      <div className="login-form-side">
        <div className="form-container">
          {/* Geri Dönüş Linki */}
          <Link to="/login" className="back-to-login">
            <i className="bi bi-arrow-left"></i>
            Giriş Ekranına Dön
          </Link>

          {/* Başlık */}
          <div className="form-header" style={{ marginTop: '24px' }}>
            <h1 className="form-main-title">Şifrenizi mi Unuttunuz?</h1>
            <p className="form-subtitle">
              Sisteme kayıtlı e-posta adresinizi girin. Size şifre sıfırlama bağlantısı göndereceğiz.
            </p>
          </div>

          {/* Başarı Mesajı */}
          {success && (
            <div className="success-message">
              <i className="bi bi-check-circle-fill"></i>
              <div>
                <strong>E-posta Gönderildi!</strong>
                <p>Şifre sıfırlama bağlantısı e-posta adresinize gönderildi. Lütfen gelen kutunuzu kontrol edin.</p>
              </div>
            </div>
          )}

          {/* Hata Mesajı */}
          {error && (
            <div className="error-message">
              <i className="bi bi-exclamation-circle-fill"></i>
              <span>{error}</span>
            </div>
          )}

          {/* Form */}
          {!success && (
            <form onSubmit={handleSubmit} className="login-form">
              {/* E-posta Alanı */}
              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  <i className="bi bi-envelope"></i>
                  E-posta Adresi
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-input"
                  placeholder="Kayıtlı e-posta adresiniz"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                  autoFocus
                />
              </div>

              {/* Gönder Butonu */}
              <button
                type="submit"
                className="submit-btn"
                disabled={loading}
                style={{ marginTop: '8px' }}
              >
                {loading ? (
                  <>
                    <span className="spinner-icon"></span>
                    Gönderiliyor...
                  </>
                ) : (
                  <>
                    <i className="bi bi-send"></i>
                    Sıfırlama Bağlantısı Gönder
                  </>
                )}
              </button>
            </form>
          )}

          {/* Başarılı Olunca Göster */}
          {success && (
            <div style={{ marginTop: '24px' }}>
              <Link to="/login" className="submit-btn" style={{ textDecoration: 'none', display: 'flex' }}>
                <i className="bi bi-arrow-left-circle"></i>
                Giriş Sayfasına Dön
              </Link>
            </div>
          )}

          {/* Alt Bilgi */}
          <div className="form-footer">
            <p className="footer-text">
              E-postanızı mı hatırlamıyorsunuz?{' '}
              <a href="mailto:destek@karadashukuk.com" className="register-link">
                Destek ile iletişime geçin
              </a>
            </p>
          </div>

          {/* Güvenlik Bilgisi */}
          <div className="security-info">
            <i className="bi bi-info-circle"></i>
            <span>Şifre sıfırlama linki 24 saat geçerlidir</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
